import { useCallback } from 'react';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import { CREDIT_CARD_FIELDS } from '../../../../components/credit-card/constants';
import { FIELD_NAMES } from '../../../../address/address-fields/constants';
import { postUpdatePayment } from '../../../utilities/api';
import { FORM_REQUIREMENTS } from '../../../utilities/constants';
import { buildSanitizedAddress } from '../../../utilities/form-sanitizer';
import { clearNonNumericalCharsFromPhone } from '../../wallet-registration/hooks/use-submit-registration';

const buildSanitizedForm = (form) => {
  if (!form) {
    return {};
  }

  const cardName = (form[FORM_REQUIREMENTS.CREDIT_CARD] || {})[CREDIT_CARD_FIELDS.CARD_NAME];

  let billingAddress = form[FORM_REQUIREMENTS.BILLING_ADDRESS];

  if (cardName) {
    billingAddress = {
      ...billingAddress,
      [FIELD_NAMES.NAME]: cardName,
    };
  }

  return {
    ...form,
    [FORM_REQUIREMENTS.BILLING_ADDRESS]: buildSanitizedAddress(billingAddress),
  };
};

export const useSubmitUpdatePayment = () => {
  const [loading, setLoading] = useAsyncSafeState(false);
  const submitForm = useCallback(
    async (form) => {
      const phoneWithOnlyNumbers = clearNonNumericalCharsFromPhone(form);
      const formToSanitize = {
        ...form,
        BillingAddress: {
          ...form.BillingAddress,
          phone: phoneWithOnlyNumbers,
        },
      };
      setLoading(true);
      try {
        const sanitizedForm = buildSanitizedForm(formToSanitize);
        const results = await postUpdatePayment(sanitizedForm, formToSanitize[FORM_REQUIREMENTS.WALLET_ID]);
        setLoading(false);
        return { results };
      } catch (errorResponse) {
        setLoading(false);
        // TODO: set with a generic error if we don't have a specific list
        return { errors: errorResponse?.response?.data?.Errors || [] };
      }
    },
    [setLoading],
  );

  return { loading, submitForm };
};
